import { jsx } from 'react/jsx-runtime';
import Toolbar from '../ui/Toolbar/Toolbar.js';
import { textFormattingGroup, basicGroup, listsGroup, positioningGroup } from '../ui/Toolbar/toolbarConfig.js';
import { ToolbarItemType } from '../ui/Toolbar/types.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { ToolbarButtonComponent } from '../ui/Toolbar/ToolbarItems.js';
import { styled } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { IconTextEditor20HideKeyboard, IconTextEditor20Close } from '@fabric-app/icons/svg';
import { useVirtualKeyboardContext } from '../../keyboard/keyboard.context.js';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';

const hideKeyboardButton = {
  icon: /* @__PURE__ */ jsx(IconTextEditor20HideKeyboard, {}),
  label: "Hide keyboard",
  type: ToolbarItemType.Button,
  key: "hideKeyboard",
  onClick: (editor) => {
    setTimeout(() => {
      editor.chain().focus().blur().run();
    }, 10);
  }
};
const doneButton = {
  icon: /* @__PURE__ */ jsx(IconTextEditor20Close, {}),
  label: "Done",
  type: ToolbarItemType.Button,
  key: "done",
  onClick: (editor) => {
    setTimeout(() => {
      editor.chain().focus().run();
    }, 10);
  }
};
const DoneButtonContainer = styled.div.withConfig({
  displayName: "FixedToolbar__DoneButtonContainer",
  componentId: "sc-7360eb4d-0"
})([
  `display:flex;align-items:center;justify-content:center;flex-shrink:0;border-left:1px solid `,
  `;height:100%;padding:5px;`
], cssVar["color-border-primary"]);
const FixedToolbar = ({ editor, onToolbarHeightChange, mobileTarget, isEditorFocused }) => {
  const { isMobileView } = useResponsive();
  const { isVisible: isKeyboardVisible } = useVirtualKeyboardContext();
  useClientLayoutEffect(() => {
    if (isEditorFocused) return;
    onToolbarHeightChange?.(0);
  }, [
    isEditorFocused,
    onToolbarHeightChange
  ]);
  if (!isMobileView || !isEditorFocused) return null;
  return /* @__PURE__ */ jsx(Toolbar, {
    editor,
    onToolbarHeightChange,
    groups: [
      textFormattingGroup,
      basicGroup,
      listsGroup,
      positioningGroup
    ],
    mobileTarget,
    suffix: isEditorFocused ? /* @__PURE__ */ jsx(DoneButtonContainer, {
      "data-prevent-touch-move": true,
      children: isKeyboardVisible ? /* @__PURE__ */ jsx(ToolbarButtonComponent, {
        editor,
        item: hideKeyboardButton
      }) : /* @__PURE__ */ jsx(ToolbarButtonComponent, {
        editor,
        item: doneButton,
        "data-prevent-touch-move": true
      })
    }) : void 0
  });
};

export { FixedToolbar as default };
//# sourceMappingURL=FixedToolbar.js.map
